<div class="flex-direction-column gap-15 container-token">

  <div class="label-lateral" style="margin-bottom: 11px">
    <span class="label">Token</span>
  </div>

  <div class="flex-direction-column gap-15">
    <app-select-one
      label="Usuário"
      placeholder="Selecione"
      [listaInput]="usuarios"
      [itemSelecionado]="usuarioSelecionado"
      campo="nome"
      [habilitarBusca]="true"
      widthFormField="100%"
      heightFormField="35px"
      [carregandoInfo]="carregandoUsuarios()"
      (selecionarItem)="selecionarUsuario($event)"
    ></app-select-one>

    <div class="flex gap-15 wrap datahora">
      <app-date-picker-padrao
        class="campo-data"
        label="Data"
        placeholder="dd/mm/aaaa"
        [data]="dataVencimento()"
        [dataMinima]="dataMinima"
        [widthFormField]="'100%'"
        [carregandoInfo]="carregandoVencimento()"
        (envioDataSelecionada)="dataVencimento.set($event)">
      </app-date-picker-padrao>

      <app-form-field
        class="campo-hora"
        label="Hora"
        type="time"
        heightFormField="35px"
        widthFormField="100%"
        placeholder="00:00"
        [carregandoInfo]="carregandoVencimento()"
        [value]="horaVencimento()"
        (changeValue)="horaVencimento.set($event)">
      </app-form-field>
    </div>

    <app-button-padrao
      backgroundColor="var(--primary)"
      color="white"
      [label]="gerando() ? 'Gerando...' : 'Gerar Token'"
      width="140px"
      fontSize="var(--text-primary-font-10-12)"
      [disabled]="gerando()"
      (buttonClick)="gerarNovoToken()"
    ></app-button-padrao>

    @if (webhook.tokenLocal) {
      <div class="flex-direction-column gap-5">
        <span class="font-12">Token Gerado</span>
        <div class="flex gap-5 width-100">
          <span class="font-12 ocultar-texto" style="color: var(--primary); width: 100%">{{ webhook.tokenLocal }}</span>
          <img class="cursor-pointer" width="18px" height="18px" src="./assets/icones/copy-icon.svg"
            alt="Copiar token" matTooltip="Copiar token" role="button" tabindex="0" (click)="copiarToken()" (keydown.enter)="copiarToken()">
        </div>
      </div>
    }

    @if (progressoVencimento !== null && progressoVencimento !== undefined) {
      <div class="flex-direction-column gap-5">
        <span class="font-12">Tempo para finalização</span>
        <div class="progress-container">
          <mat-progress-bar
            mode="determinate"
            style="width: 100%; height: 16px; border-radius: 4px;"
            [value]="progressoVencimento"
          >
          </mat-progress-bar>
          <span class="exibicao-data-expiracao">{{ webhook.dataVencimento | date: 'dd/MM/yyyy - HH:mm' }} </span>
        </div>
      </div>
    }

  </div>

</div>
